import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '第11届渝商评选';
const baseUrl = '20230901YSPX';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/list`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'list',
      name: `${baseUrl}-list`,
      component: () => import('./pages/List.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'peopleDetail',
      name: `${baseUrl}-peopleDetail`,
      component: () => import('./pages/PeopleDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'caseDetail',
      name: `${baseUrl}-caseDetail,`,
      component: () => import('./pages/CaseDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'link',
      name: `${baseUrl}-link,`,
      component: () => import('./pages/Link.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
      children: [
        // 充值页面
        {
          path: 'top-up',
          name: `${baseUrl}-user-top-up`,
          component: () => import('./components/Topup.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        // 充值记录
        {
          path: 'record',
          name: `${baseUrl}-user-record`,
          component: () => import('./components/Record.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
        // 消费记录
        {
          path: 'consume',
          name: `${baseUrl}-user-consume`,
          component: () => import('./components/Consume.vue'),
          meta: {
            title: PAGE_TITLE,
          },
        },
      ],
    },
  ],
};

export default route;
